
    import * as React from 'react';

    const NextCircle32 = ({ color = 'currentcolor', height = '32px', width = '32px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 32 32" style={svgStyle}><g><path d="M16 31c8.285 0 15-6.717 15-15 0-8.283-6.715-15-15-15S1 7.717 1 16c0 8.283 6.715 15 15 15zm0-1C8.268 30 2 23.731 2 16S8.268 2 16 2s14 6.269 14 14-6.268 14-14 14z" /><path d="M21.354 15.707l-4.31-3.972.677-.735 5.577 5.138-5.577 5.137-.678-.735 4.161-3.833H8.75v-1h12.604z" /></g></svg>
        </div>
      );
    };

    NextCircle32.displayName = 'NextCircle32';

    export default NextCircle32;
  